export const priceFormatter = new Intl.NumberFormat('fr', {
	style: 'currency', currency: 'EUR', minimumFractionDigits: 2
})
